const STORAGE_KEY = 'zhima_user'

export function saveUser (payload) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
  } catch (e) {
    /* ignore quota errors */
  }
}

export function getUser () {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export function clearUser () {
  localStorage.removeItem(STORAGE_KEY)
}

export function isLoggedIn () {
  const user = getUser()
  return !!(user && user.userId)
}

export function saveSelectedClass (classInfo) {
  const user = getUser()
  if (!user) return
  saveUser({ ...user, selectedClass: classInfo })
}

export function getSelectedClass () {
  const user = getUser()
  return user ? user.selectedClass : null
}



// WEBPACK FOOTER //
// ./src/utils/auth.js